import {
  FUTURES_GLOBAL_HINT,
  FUTURES_ODDS_METHOD_OPTIONS,
  FUTURES_PERSONAL_DIRECTION_OPTIONS,
  FUTURES_PERSONAL_HINT,
  PERPETUAL_PERSONAL_DIRECTION_OPTIONS,
  PERPETUAL_GLOBAL_DIRECTION_OPTIONS,
  TIMED_DIRECTION_OPTIONS,
} from './controlConstants';

/**
 * 各玩法控獎欄位定義（Phase 1 前端 schema）。
 */
export const CONTROL_SCHEMA = {
  TIME_LIMITED: {
    personal: {
      hints: ['未設定偏移範圍時，沿用該玩法全局控獎的最小／最大值。'],
      columns: ['memberId', 'direction', 'minValue', 'maxValue', 'enabled'],
      formFields: ['memberId', 'direction', 'minValue', 'maxValue', 'enabled'],
      directionOptions: TIMED_DIRECTION_OPTIONS,
      directionField: 'direction',
    },
    global: {
      hints: ['隨機偏移單位為百分比（%）。'],
      formFields: ['enabled', 'direction', 'minValue', 'maxValue'],
      directionOptions: TIMED_DIRECTION_OPTIONS,
      directionField: 'direction',
    },
  },
  PERPETUAL: {
    personal: {
      hints: [],
      columns: ['memberId', 'direction', 'minValue', 'maxValue', 'enabled'],
      formFields: ['memberId', 'direction', 'minValue', 'maxValue', 'enabled'],
      directionOptions: PERPETUAL_PERSONAL_DIRECTION_OPTIONS,
      directionField: 'controlWin',
    },
    global: {
      hints: ['滑價隨機值為整數。'],
      formFields: ['enabled', 'direction', 'minValue', 'maxValue'],
      directionOptions: PERPETUAL_GLOBAL_DIRECTION_OPTIONS,
      directionField: 'direction',
    },
  },
  FUTURES: {
    personal: {
      hints: [FUTURES_PERSONAL_HINT],
      columns: ['memberId', 'direction', 'enabled'],
      formFields: ['memberId', 'direction', 'enabled'],
      directionOptions: FUTURES_PERSONAL_DIRECTION_OPTIONS,
      directionField: 'controlWin',
    },
    global: {
      hints: [
        FUTURES_GLOBAL_HINT,
        '「系統控開關」關閉後僅保留賠率配置，不執行金額差系統控。',
        '系統控僅在買漲與買跌金額差超過起控金額時生效；概率 100 表示每局必控。',
      ],
      formFields: [
        'enabled',
        'isRealOdds',
        'minRandomOdds',
        'maxRandomOdds',
        'startKillAmount',
        'killProbability',
      ],
      oddsOptions: FUTURES_ODDS_METHOD_OPTIONS,
    },
  },
};

export function getControlSchema(playType, mode) {
  return CONTROL_SCHEMA[playType]?.[mode] || null;
}
